export default function Logo({ size = 'default', showText = true }) {
  const sizes = {
    small: { icon: 'w-8 h-8', text: 'text-lg', m: 'text-sm' },
    default: { icon: 'w-10 h-10', text: 'text-xl', m: 'text-lg' },
    large: { icon: 'w-16 h-16', text: 'text-2xl', m: 'text-xl' }
  };

  const s = sizes[size] || sizes.default;

  return (
    <div className="flex items-center space-x-3">
      {/* Globe Icon with M */}
      <div className={`${s.icon} rounded-full bg-gradient-to-br from-[#D4AF37] via-[#F7E7CE] to-[#D4AF37] flex items-center justify-center relative overflow-hidden`}>
        {/* Globe lines */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-full h-[1px] bg-[#0B0C10]/20 absolute" />
          <div className="w-[1px] h-full bg-[#0B0C10]/20 absolute" />
          <div className="w-full h-full border border-[#0B0C10]/20 rounded-full absolute" style={{ transform: 'scaleX(0.6)' }} />
          <div className="w-full h-full border border-[#0B0C10]/20 rounded-full absolute" style={{ transform: 'scaleY(0.6)' }} />
        </div>
        {/* M Letter */}
        <span className={`text-[#0B0C10] font-bold ${s.m} heading-display relative z-10`}>M</span>
      </div>
      
      {showText && (
        <div>
          <span className={`${s.text} font-semibold text-[#D4AF37] heading-display tracking-tight`}>
            Mulberry
          </span>
          <span className={`${s.text} font-light text-white heading-display ml-1`}>
            World
          </span>
        </div>
      )}
    </div>
  );
}
